import { createStyles, makeStyles } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const useStyles = makeStyles(() =>
  createStyles({
    subHeaderRow: {
      width: '380px',
      padding: '5px',
    },
    subHeaderText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
    },
    sessionStatusRow: {
      width: '380px',
      padding: '5px',
    },
    sessionStatus: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '15px',
      color: 'rgba(44, 45, 62, 0.8)',
    },
    subHeader: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '13px',
    },
    normalPaper: {
      backgroundColor: '#ff0000',
    },
    picker: {
      '& .MuiPickersBasePicker-pickerView': {
        minHeight: '505px',
      },
      position: 'relative',
      marginBottom: '500px',
    },
    monthField: {
      width: '130px',
      height: '30px',
      fontSize: '16px',
      display: 'inline',
      zIndex: 0,
    },
    monthLabel: {
      fontSize: '12px',
    },
    yearField: {
      width: '130px',
      height: '30px',
      fontSize: '16px',
      display: 'inline',
      zIndex: 0,
    },
    plaster: {
      backgroundColor: '#FFFFFF',
      position: 'absolute',
      width: '100%',
      height: '30px',
      top: '5px',
      zIndex: 0,
    },
    sessionStateChangeConditionsList: {
      textAlign: 'left',
      width: '450px',
      margin: 'auto',
      listStyleType: 'none',
      '& li': {
        margin: '5px 0 5px 0',
        '& svg': {
          width: '20px',
          marginRight: '15px',
          position: 'relative',
          top: '7px',
        },
      },
    },
    successIcon: {
      color: '#347F42',
    },
    errorIcon: {
      color: '#BC0000',
    },
  }),
);
export const materialTheme = createTheme({
  palette: {
    primary: {
      main: '#3C419A',
    },
  },
});

export const DateTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: 'unset',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {},
  },
});
